import { useState, useEffect } from "react";

const useFileUpload = ({
  defaultUrl = null,
  fileList = null,
  onRemoveHandler,
  onRemoveConfirmHandler,
  inputId = "file-upload",
}) => {
  const [previewUrl, setPreviewUrl] = useState(defaultUrl || null);
  const [isRemoved, setIsRemoved] = useState(false);

  useEffect(() => {
    if (fileList && fileList[0]) {
      const objectUrl = URL.createObjectURL(fileList[0]);
      setPreviewUrl(objectUrl);
      setIsRemoved(false); // Reset removed state when new file is selected

      return () => URL.revokeObjectURL(objectUrl); // cleanup
    } else if (!isRemoved) {
      // When fileList is empty and not removed, show the defaultUrl
      setPreviewUrl(defaultUrl || null);
    }
  }, [fileList, defaultUrl, isRemoved]);

  const handleRemove = () => {
    if (onRemoveConfirmHandler) {
      // Use confirmation handler if provided
      onRemoveConfirmHandler(() => {
        setPreviewUrl(null);
        setIsRemoved(true);
        onRemoveHandler();
      });
    } else {
      // Fallback to immediate remove
      setPreviewUrl(null);
      setIsRemoved(true);
      onRemoveHandler();
    }
  };

  const handleChange = () => {
    document.getElementById(inputId)?.click();
    onRemoveHandler();
  };

  return {
    previewUrl,
    isRemoved,
    handleRemove,
    handleChange,
  };
};

export default useFileUpload;
